import {httpClient} from './httpClient';

const END_POINT = '/transactions/';

const getAllTransactions = (params = {}) => httpClient.get(END_POINT, { params });

const deleteTransaction = (transaction_id) => httpClient.delete(END_POINT + transaction_id + "/");

const updateTransaction = (transaction_id, body) => httpClient.patch(END_POINT + transaction_id + "/", body);

const getTransactionSummary = (params = {}) => httpClient.get("/summary/", { params });

export {
    getAllTransactions, getTransactionSummary, deleteTransaction, updateTransaction
}
